export const getChangePct = ({
  baseline,
  latest,
}: {
  baseline: number | undefined | null;
  latest: number | undefined | null;
}): number => {
  // TODO: MVP-5183 evaluate whether this calculation should come from the BE / Science, if available there remove this function
  let changePct = 0;

  if (typeof baseline !== 'number' || typeof latest !== 'number') {
    return changePct;
  }

  if (baseline === 0 && latest === 0) {
    changePct = 0;
  } else if (baseline === 0) {
    changePct = 100;
  } else if (latest === 0) {
    changePct = -100;
  } else {
    changePct = ((latest - baseline) / baseline) * 100;
  }

  return changePct;
};
